module.exports = __webpack_public_path__ + "static/media/knowledge_v2.caf3deed.jpg";